import { render } from "./TargetForm.vue?vue&type=template&id=bf994924"
import script from "./TargetForm.vue?vue&type=script&lang=js"
export * from "./TargetForm.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__